var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"},on:{"after-leave":_vm.handleAfterLeave}},[(_vm.visible)?_c('div',{class:['toast', _vm.type],style:(`z-index:${_vm.zIndex}`)},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }